<template>
  <section>
    <gs-header title="Thêm mới permissions"
      :breadcrumbs="[
        {title: 'Quản lý permissions', route: {name: 'permission'}}
      ]"
    >
    </gs-header>
    <div class="padding-sm-all">
      <el-form :model="localPermission" :rules="rules" ref="createPermissionForm" label-width="200px" label-position="top" @submit.prevent.native="validateBeforeSubmitRole('createPermissionForm')">
        <el-row :gutter="20" class="remove-margin">
          <el-col :span="12">
            <el-form-item label="Tên" prop="name">
              <el-input v-model="localPermission.name" placeholder="Tên"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Tên hiển thị">
              <el-input v-model="localPermission.display_name" placeholder="Tên hiển thị"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="Mô tả">
              <el-input type="textarea" :rows="3" v-model="localPermission.description" placeholder="Mô tả"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">Chọn tất cả</el-checkbox>
            <el-checkbox-group v-model="localPermission.prefix" class="margin-top margin-lg-bottom">
              <el-checkbox v-for="(prefix, key, index) in permissionHelpers.prefixs" :key="key" :label="key">{{prefix}}</el-checkbox>
            </el-checkbox-group>
          </el-col>
        </el-row>
        <el-form-item>
          <button :disabled="submitting" class="ui blue basic small button" native-type="submit">Thêm mới</button>
        </el-form-item>
      </el-form>
    </div>
  </section>
</template>

<script>
import { createPermission } from 'src/api/permissions'
import { head, forEach } from 'lodash'
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'NewPermission',
  data () {
    return {
      submitting: false,
      isIndeterminate: true,
      checkAll: false,
      localPermission: {
        name: '',
        display_name: '',
        description: '',
        prefix: []
      },
      rules: {
        name: [
          {required: true, message: 'Bạn chưa nhập tên permission', trigger: 'change'},
          {max: 255, message: 'Tên permission phải nhỏ hơn 255 ký tự', trigger: 'change'}
        ]
      }
    }
  },
  computed: {
    ...mapGetters('permission', ['permissionHelpers'])
  },
  methods: {
    ...mapActions('permission', ['getAllPermissionsHelpers']),
    validateBeforeSubmitRole () {
      this.submitting = true
      this.$refs.createPermissionForm.validate(valid => {
        if (valid) {
          this.changedData = false
          createPermission(this.localPermission).then(response => {
            switch (response.code) {
              case 200:
                this.$store.dispatch('showNotify', {
                  title: 'Thêm mới thành công',
                  body: 'Thêm permission  thành công'
                })
                this.reloadGsTableAfterRedirect({name: 'permission'}, 'permissions')
                this.toggleLoadding(false)
                this.submitting = false
                break
              case 422:
                let er = response.data.errors
                let message = head(er[Object.keys(er)[0]])
                this.$store.dispatch('showNotify', {
                  title: 'Vui lòng kiểm tra thông tin cần nhập',
                  body: message,
                  type: 'warning'
                })
                this.toggleLoadding(false)
                this.submitting = false
                break
              default:
                this.$store.dispatch('showNotify', {
                  title: 'Vui lòng kiểm tra thông tin cần nhập',
                  body: 'Tạo permission thất bại vui lòng kiểm tra lại thông tin',
                  type: 'warning'
                })
                this.toggleLoadding(false)
                this.submitting = false
            }
          })
        } else {
          this.$store.dispatch('toggleLoadding', false, {root: true})
          this.$store.dispatch('showNotify', {
            title: 'Vui lòng kiểm tra thông tin cần nhập',
            type: 'warning'
          })
          this.submitting = false
          return false
        }
      })
    },
    handleCheckAllChange () {
      if (this.checkAll) {
        let listPermission = []
        forEach(this.permissionHelpers.prefixs, (value, key) => {
          listPermission.push(key)
        })
        this.localPermission.prefix = listPermission
      } else {
        this.localPermission.prefix = []
      }
      this.isIndeterminate = false
    }
  },
  mounted () {
    setTimeout(() => {
      this.watching = true
    }, 100)
    if (!Object.keys(this.permissionHelpers).length) {
      this.getAllPermissionsHelpers()
    }
  },
  watch: {
    localPermission: {
      handler: function (value) {
        if (this.watching) {
          this.changedData = true
        }
      },
      deep: true
    }
  }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// NewPermission.vue?272ee90f